export const APP_VERSION_RELOAD_MARKER_KEY = "df:app-version-recovery:v1";
